import Vue from 'vue'
import Router from 'vue-router'
import auth from './auth'
import error from './error'
import store from '../store'
import MenuUtils from '@/utils/menuUtils'
import dashboard from './dashboard'
Vue.use(Router)


// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export const constantRouterMap = [
  {
    path: '/',
    redirect: 'page_mytask_mytask_index'
    // redirect: 'page_Index_Index'
  },
  {
    path: '/page_mytask_dashboardGuide_index',
    component: resolve => require(['../page/mytask/dashboardGuide/index.vue'], resolve)
  },
  {
    path: '/mytask',
    component: resolve => require(['../page/mytask/mytask/index.vue'], resolve)
  },
  {
    path: '/recycling',
    component: resolve => require(['../page/mytask/recycling/index.vue'], resolve)
  },
  ...auth,
  ...dashboard,
  ...error
]

const router = new Router({
  mode: 'history', // require service support
  //base:'wds',   //wds
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

//刷新页面的时候先检查本地是否有路由数据 如果没有就请求新的数据
let menus = JSON.parse(window.sessionStorage.getItem('menus'))
if (menus) {
  if (!store.state.tagsView.sidebar.opened) {
    store.dispatch('tagsView/toggleSideBar')
  }
  let routes = []
  MenuUtils(routes, menus)

  router.addRoutes(routes)

}

const equalsIgnoreCase = function(text01, text02) {
  return (text01 || '').toLowerCase() == (text02 || '').toLowerCase();
}

const notEqualsIgnoreCase = function(text01, text02) {
  return !equalsIgnoreCase(text01, text02);
}

/**
 * 账号失效，重定向登录画面
 */
function accountInvalidationRedirect(toPath, next) {
  if (toPath != '/login' && toPath != '/404' && toPath != '/mytask' ) {
    const currentLoginUserNo = localStorage.getItem('ms_username');
    const globalVarForUserNo = (JSON.parse(sessionStorage.getItem("user")) || {}).userNo;
    console.log("toPath=" + toPath + ", currentLoginUserNo=" + currentLoginUserNo + ", globalVarForUserNo=" + globalVarForUserNo)
    if (globalVarForUserNo && notEqualsIgnoreCase(globalVarForUserNo, currentLoginUserNo)) {
      console.log(toPath,'===================///toPath------router-----index')
      Vue.prototype.$alert('当前账号登录已失效，请重新登录！', '通知', {
        confirmButtonText: '确定',
        beforeClose: function(action, instance, done){
          done();
          next('/login');
        }
      })
    }
  }
}

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  accountInvalidationRedirect(to.path, next);

  //邮件
  if (to.path == '/approvePos_show' || to.path == '/approveWms_show') {
    //console.log('===before next===')
    next();
  } else if (to.path === '/mytask' || to.path === '/recycling' || to.path === '/page_mytask_dashboardGuide_index'){
    next();
  } else {

    let data = JSON.parse(window.sessionStorage.getItem('menus'))

    //退出登录来这里
    if (data && to.path === '/login') {
      //这里不使用router进行跳转，是因为，跳转到登录页面的时候，是需要重新登录，获取数据的，这个时候，会再次向router实例里面add路由规则，
      //而next()跳转过去之后，没有刷新页面，之前的规则还是存在的，但是使用location的话，可以刷新页面，当刷新页面的时候，整个app会重新加载
      //而我们在刷新之前已经把sessionStorage里的user移除了，所以上面的添加路由也不行执行
      window.sessionStorage.removeItem('menus')
      window.location.href = '/login'
    }
    if (!data && to.path !== '/login') {

      //打开动态二维码页面
      let rdcNo = to.query.rdcNo

      rdcNo ? next(`/login?rdcNo=${rdcNo}`) : next('/login')
    } else if (to.meta.permission) {
      // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
      role === 'admin' ? next() : next('/403')
    } else {
      // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
      if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
        Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
          confirmButtonText: '确定'
        })
      } else {
        next()
      }
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js